const APIURL = 'https://heastro.in/heastro-service';
// const APIURL = 'https://heastro.in/heastro-test-service';
export const API_SECRET_KEY = process.env.REACT_APP_API_SECRET_KEY || "hestro@jiffy@123";
export const API_MODE = "w";
export default APIURL;           